export const levels = {
  '1': {
    words: ['the', 'be', 'to', 'of', 'and', 'a', 'in', 'that', 'have', 'I'],
    difficulty: 'Easy',
    description: 'Common three-letter words'
  },
  '2': {
    words: ['about', 'there', 'right', 'think', 'would', 'could', 'should', 'their'],
    difficulty: 'Medium',
    description: 'Five-letter words'
  },
  '3': {
    words: ['beautiful', 'confident', 'important', 'necessary', 'different', 'wonderful'],
    difficulty: 'Hard',
    description: 'Long words'
  },
  '4': {
    words: ['hello,', 'world!', 'how', 'are', 'you?', 'I\'m', 'good.', 'thanks!'],
    difficulty: 'Medium',
    description: 'Basic punctuation'
  },
  '5': {
    words: ['programming', 'javascript', 'typescript', 'python', 'java', 'react', 'angular'],
    difficulty: 'Hard',
    description: 'Programming terms'
  },
  '6': {
    words: ['The', 'Quick', 'Brown', 'Fox', 'Jumps', 'Over', 'The', 'Lazy', 'Dog.'],
    difficulty: 'Hard',
    description: 'Capitalization practice'
  },
  '7': {
    words: ['Hello, world!', 'How are you?', 'I\'m good.', 'What\'s new?', 'Nothing much!'],
    difficulty: 'Expert',
    description: 'Full sentences with punctuation'
  },
  '8': {
    words: ['Don\'t you love typing?', 'Yes, I really do!', 'Practice makes perfect.', 'Keep going!'],
    difficulty: 'Expert',
    description: 'Complex sentences'
  },
  '9': {
    words: ['The user said, "Hello!"', 'Is this working? Yes!', 'Stop; think; type.', 'Ready, set, go!'],
    difficulty: 'Master',
    description: 'Advanced punctuation'
  },
  '10': {
    words: [
      'The quick brown fox jumps over the lazy dog.',
      'Pack my box with five dozen liquor jugs!',
      'How vexingly quick daft zebras jump!',
      'The five boxing wizards jump quickly.'
    ],
    difficulty: 'Master',
    description: 'Pangrams and complex sentences'
  }
}; 